import { SET_COUNTRIES_DATA } from "app/action_types/country_filter_action-types";

type CountriesData = Record<string, number>;
type CountryFilterState = {
    countriesData: CountriesData | null;
};
type Action = {
    type: string;
    countriesData: CountriesData;
};

export function countryFilter(state: CountryFilterState = { countriesData: null }, action: Action): CountryFilterState {
    switch (action.type) {
        case SET_COUNTRIES_DATA: {
            return { ...state, countriesData: action.countriesData };
        }
        default:
            return state;
    }
}
